import React from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    accordion: {
        marginTop: theme.spacing(2),
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        border: '1px solid #e0e0e0',
        borderRadius: '4px !important',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        color: '#3f51b5',
    },
}));

const Pergunta = ({ pergunta, children }) => {
    const classes = useStyles();
    return (
        <Accordion className={classes.accordion}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                <Typography className={classes.heading}>{pergunta}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography variant="body2" component="div">
                    {children}
                </Typography>                
            </AccordionDetails>
        </Accordion>
    );
};

export default Pergunta;
